import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-cd-textarea',
  templateUrl: './cd-textarea.component.html',
  styleUrls: ['./cd-textarea.component.scss'],
  imports: [],
})
export class CdTextareaComponent implements OnChanges {
  @Input() label = '';
  @Input() placeholder = '';
  @Input() maxlength?: number;
  @Input() minRows?: number;
  @Input() maxRows = 8;
  @Input() value = '';
  @Input() height?: string;
  @Input() fontSize?: string;
  @Output() valueChange = new EventEmitter<string>();

  internalValue = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.internalValue = changes['value'].currentValue ?? '';
    }
  }

  onInput(event: Event): void {
    this.internalValue = (event.target as HTMLTextAreaElement).value;
    this.valueChange.emit(this.internalValue);
  }

  get currentLength(): number {
    return this.internalValue.length;
  }
}
